import React, { useState } from "react";
import { TextField } from "@mui/material";
import { COLORS } from "../../constants";
import { StyledTextFieldProps } from "../../types";

export const StyledTextField: React.FC<StyledTextFieldProps> = (props) => {
  const { validate, ...textFieldProps } = props;
  const [error, setError] = useState<string | null>(null);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;

    if (validate) {
      const errorMessage = validate(
        textFieldProps.type === "number" ? parseFloat(value) : value
      );
      setError(errorMessage);
    }

    if (textFieldProps.onChange) {
      textFieldProps.onChange(e);
    }
  };

  const handleBlur = () => {
    if (
      validate &&
      textFieldProps.value !== undefined &&
      textFieldProps.value !== ""
    ) {
      const errorMessage = validate(
        textFieldProps.type === "number"
          ? parseFloat(textFieldProps.value as string)
          : (textFieldProps.value as string)
      );
      setError(errorMessage);
    }
  };

  const handleWheel = (e: React.WheelEvent<HTMLDivElement>) => {
    // Prevent wheel scroll from changing number values
    if (textFieldProps.type === "number") {
      (e?.target as HTMLElement)?.blur();
    }
  };

  return (
    <TextField
      {...textFieldProps}
      onChange={handleChange}
      onBlur={handleBlur}
      onWheel={handleWheel}
      error={!!error}
      helperText={error || textFieldProps.helperText}
      sx={{
        "& .MuiOutlinedInput-root": {
          "&:hover fieldset": {
            borderColor: error ? COLORS.ERROR : COLORS.PRIMARY,
          },
          "&.Mui-focused fieldset": {
            borderColor: error ? COLORS.ERROR : COLORS.PRIMARY,
          },
        },
        "& .MuiInputLabel-root.Mui-focused": {
          color: error ? COLORS.ERROR : COLORS.PRIMARY,
        },
        ...textFieldProps.sx,
      }}
    />
  );
};
